import Vue from 'vue';
import moment from 'moment';

const request = require('request');
const FeedParser = require('feedparser');
const parseXMLString = require('xml2js').parseString;

const mutations = {
  setCapAlert(state, alert) {
    Vue.set(state, 'alert', alert);
  },
};

const actions = {
  fetchAlerts({ commit }, url) {
    const req = request(url);
    const feedParser = new FeedParser();
    const currentTime = moment();

    req.on('response', (res) => {
      if (res.statusCode === 200) {
        req.pipe(feedParser);
      }
    });

    feedParser.on('readable', () => {
      let item = feedParser.read();

      while (item) {
        request({
          url: item.link,
          headers: {
            Accept: 'application/cap+xml',
          },
        }, (error, response, body) => {
          if (error) {
            return;
          }

          parseXMLString(body, (err, xml) => {
            const capAlert = xml.alert;
            if (err) return;
            if (!capAlert || !Object.prototype.hasOwnProperty.call(capAlert, 'info')) return;

            capAlert.info.forEach((info) => {
              const alertInEffect = (alert) => {
                let expires = moment().add(1, 'hours');
                if (Object.prototype.hasOwnProperty.call(alert, 'expires')) {
                  expires = moment(alert.expires[0]);
                }

                return (expires < currentTime);
              };

              if (!alertInEffect(info)) return;

              const alert = { event: info.event[0] };

              if (Object.prototype.hasOwnProperty.call(info, 'instruction')) {
                alert.instruction = info.instruction[0];
              }

              if (Object.prototype.hasOwnProperty.call(info, 'description')) {
                alert.description = info.description[0];
              }

              commit('setCapAlert', alert);
            });
          });
        });
        item = feedParser.read();
      }
    });
  },
};

export default {
  state: {
    alert: {
      description: null,
      instruction: null,
      title: null,
    },
  },
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/capAlerts/index.js